import {
  Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  styled,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";

import NewRequestSubbar from "../../../../Components/Subbars/NewRequestSubbar";
import FullTaskTopbar from "../../../../Components/Topbars/FullTaskTopbar";

import AddIcon from "@mui/icons-material/Add";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import GraphicEqOutlinedIcon from "@mui/icons-material/GraphicEqOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import RuleOutlinedIcon from "@mui/icons-material/RuleOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SubtitlesOutlinedIcon from "@mui/icons-material/SubtitlesOutlined";
import TvOutlinedIcon from "@mui/icons-material/TvOutlined";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import MarketplacePlaceholdersPanel from "../../../../Components/Panels/MarketplacePlaceholdersPanel";
import FullTaskLayout from "../../../../Layouts/FullTask";
import { useToggle } from "../../../../Utils/Hooks/useToggle";

import { FC, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router";
import GroupColumnTable, { GroupColumnTableProps } from "../../../../Components/Table/GroupColumnTable";
import TableSkeleton from "../../../../Components/Table/TableSkeleton";
import { assetService, cacheService, EnvType, ingestService, supportService } from "../../../../Core/Api/services";
import { NewRequestColumnGroup } from "../../../../Core/Api/Types/ingest-config-pack-column-set";
import {
  CreateRequests,
  DuplicateRow,
  GenerateAssets,
  GetCanUpdateOrSaveConfig,
  GetColumnErrorNumberCached,
  GetColumnGroups,
  GetFetchedPacks,
  GetGroupErrors,
  GetIsLoading,
  GetIsMarketplaceLoading,
  GetIsTableErrored,
  GetRowGroupedErrorNumberCached,
  GetRows,
  GetSelectedPack,
  GetSelectedTabValue,
  GetSelectedTitles,
  SetBackups,
  SetFetchedColumnGroups,
  SetFetchedPacks,
  SetSelectedTab,
  SetSelectedTitles,
  UnselectPlaceholderById,
} from "../../../../Redux/Reducers/redux-slice-new-request";
import { useAppDispatch, useAppSelector } from "../../../../Redux/redux-store";
import { routePaths } from "../../../../Router/router";
import useCustomSnackbar from "../../../../Utils/Hooks/useCustomSnackbar";

import CheckIcon from "@mui/icons-material/Check";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PublicIcon from "@mui/icons-material/Public";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { GridRowsProp, useGridApiRef } from "@mui/x-data-grid-premium";
import HelpPopup from "../../../../Components/HelpPopup";
import RequiredIndicator from "../../../../Components/Misc/RequiredIndicator";
import { ModalContext } from "../../../../Components/Modals";
import ModalDuplicateRowName, {
  ModalDuplicateRowNameElementProps,
} from "../../../../Components/Modals/ModalDuplicateRowName/modal-duplicate-row-name";
import ModalNewRequestBroker, {
  ModalNewRequestBrokerElementProps,
} from "../../../../Components/Modals/ModalNewRequestBroker/modal-new-request-broker";
import ModalNewRequestCheck, {
  ModalNewRequestCheckElementProps,
} from "../../../../Components/Modals/ModalNewRequestCheck/modal-new-request-check";
import ModalNewRequestDeleteConfig, {
  ModalNewRequestDeleteConfigElementProps,
} from "../../../../Components/Modals/ModalNewRequestDeleteConfig/modal-new-request-delete-config";
import ModalNewRequestLoadConfig, {
  ModalNewRequestLoadConfigElementProps,
} from "../../../../Components/Modals/ModalNewRequestLoadConfig/modal-new-request-load-config";
import ModalNewRequestSaveConfig, {
  ModalNewRequestSaveConfigElementProps,
} from "../../../../Components/Modals/ModalNewRequestSaveConfig/modal-new-request-save-config";
import ModalNewRequestUpdateConfig, {
  ModalNewRequestUpdateConfigElementProps,
} from "../../../../Components/Modals/ModalNewRequestUpdateConfig/modal-new-request-update-config";
import NewRequestFilterPanel from "../../../../Components/Panels/NewRequestPanels/new-request-filters-panel";
import NewRequestPanel from "../../../../Components/Panels/NewRequestPanels/new-request-panel";
import TableCellNewRequestField from "../../../../Components/Table/TableCellNewRequestField/table-cell-new-request-field";
import { StartupHelpTutorialType } from "../../../../Core/Api/Types/startup-help-tutorial-type";
import { DownloadTableAsCsv } from "../../../../Redux/Reducers/redux-slice-new-request";
import { TutorialContext } from "../../../../Utils/Helpers/tutorial";
import { immerable } from "immer";
import { UserHasAcl } from "../../../../Utils/helpers";
import { AclTypes } from "../../../../Core/Api/Types/acl-types";
import ModalReportIssue, {
  ModalReportIssueElementProps,
} from "../../../../Components/Modals/ModalReportIssue/modal-report-issue";
import GlobalConst from "../../../../Core/Utils/Constants/globals";
import { useTranslation } from "react-i18next";

function IngestNewRequest() {
  const { t } = useTranslation();
  const { active: panelMarketplaceOpen, toggle: toggleMarketplacePanel } = useToggle(false);
  const { active: panelManageTitlesOpen, toggle: toggleManageTitlePanel } = useToggle(false);
  const { active: panelFilterOpen, toggle: toggleFilterPanel } = useToggle(false);

  const rowType: GridRowsProp = useMemo(() => [], []);
  type Row = (typeof rowType)[number];
  const apiGrid = useGridApiRef();

  const params = useParams();
  const dispatch = useAppDispatch();
  const enqueueSnackbar = useCustomSnackbar();
  const modalContext = useContext(ModalContext);
  const { openModal } = { ...modalContext };

  const isLoading = useAppSelector(GetIsLoading);
  const isMarketplaceLoading = useAppSelector(GetIsMarketplaceLoading);

  const selectedTitles = useAppSelector(GetSelectedTitles);
  const fetchedPacks = useAppSelector(GetFetchedPacks);
  const selectedPack = useAppSelector(GetSelectedPack);
  const columnGroups = useAppSelector(GetColumnGroups);
  const rows = useAppSelector(GetRows);
  const selectedTab = useAppSelector(GetSelectedTabValue);
  const isTableErrored = useAppSelector(GetIsTableErrored);
  const groupErrors = useAppSelector(GetGroupErrors);

  const [helpPopupAnchorEl, setHelpPopupAnchorEl] = useState<HTMLElement | null>(null);
  const tutorialContext = useContext(TutorialContext);
  const { setTutorialPage } = { ...tutorialContext };
  const [showTuto, setShowTuto] = useState<boolean>(false);

  const handleDuplicatePlaceholderClick = (rowId: number, originalPlaceholderName: string) => {
    if (!openModal) return;
    openModal<ModalDuplicateRowNameElementProps>(ModalDuplicateRowName, {
      originalName: originalPlaceholderName,
      onConfirm: (placeholderName) => {
        dispatch(DuplicateRow({ rowId, name: placeholderName }));
      },
    });
  };

  const computeTableColumns = useCallback((columnGroups: NewRequestColumnGroup[]): GroupColumnTableProps["columns"] => {
    let output: GroupColumnTableProps["columns"] = [
      {
        field: "placeHolderName",
        headerName: t("common:name"),
        width: 400,
        sortable: false,
        disableColumnMenu: true,
        renderCell: (data: Row) => (
          <NameCell direction="row" alignItems="center" sx={{ my: 0.5 }}>
            <Typography
              color="text.secondary"
              fontWeight={500}
              sx={(theme) => ({
                ...theme.helpers(theme).ellipsis,
                flex: 1,
                wordBreak: "break-all",
                wordWrap: "break-word",
                whiteSpace: "normal",
              })}
            >
              {data.value}
            </Typography>
            {/* <TableCellStringExpend data={data} /> */}
            {data.row["isOutdated"] && (
              <Tooltip
                placement="top"
                arrow
                title={
                  <Typography variant="body2">{t("tooltip:title.placeholderHasBeenUpdatedSinceLastSave")}</Typography>
                }
              >
                <WarningAmberOutlinedIcon color="warning" />
              </Tooltip>
            )}

            <Tooltip
              placement="top"
              arrow
              title={<Typography variant="body2">{t("tooltip:title.duplicateRow")}</Typography>}
            >
              <IconButton sx={{ ml: 1 }} onClick={() => handleDuplicatePlaceholderClick(data.row["id"], data.value)}>
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
            <Tooltip placement="top" arrow title={<Typography variant="body2">{t("common:removeRow")}</Typography>}>
              <IconButton
                color="error"
                sx={{ ml: 1 }}
                onClick={() => dispatch(UnselectPlaceholderById(data.row["id"]))}
              >
                <DeleteOutlineIcon />
              </IconButton>
            </Tooltip>
          </NameCell>
        ),
      },
    ];

    columnGroups.forEach((columnGroup) => {
      output.push({
        field: columnGroup.name,
        width: 56,
        sortable: false,
        disableColumnMenu: true,
        renderHeader: () => {
          switch (columnGroup.name) {
            case "Localization":
              return <PublicIcon />;
            case "Audio":
              return (
                <Box id="tutorial-request-groups">
                  <GraphicEqOutlinedIcon />
                </Box>
              );
            case "Video":
              return <TvOutlinedIcon />;
            case "Original material":
              return <Inventory2OutlinedIcon />;
            case "Subtitle":
              return <SubtitlesOutlinedIcon />;
            default:
              return <SettingsOutlinedIcon />;
          }
        },
        renderCell: (data: Row) => (
          <TableCellRequestStatus
            columnsIds={columnGroup.columns.flatMap((c) => c.fieldId)}
            placeholderRowId={data.row["id"]}
          />
        ),
        align: "center",
        headerAlign: "center",
      });
      columnGroup.columns.forEach((column, columnIndex) => {
        output.push({
          field: column.metadata.tagName!,
          groupBy: columnGroup.name,
          minWidth: 200,
          flex: 200,
          sortable: false,
          disableColumnMenu: true,
          renderHeader: () => <TableCellHeader headerName={column.label} columnMetadataFieldId={column.fieldId} />,
          renderCell: (data: Row) => <TableCellNewRequestField fieldInfos={data.value} />,
        });
      });
    });

    return output;
  }, []);

  const tableColumns = useMemo(
    () => (columnGroups.length > 0 ? computeTableColumns(columnGroups) : []),
    [columnGroups, computeTableColumns]
  );

  const displayTable = useMemo(
    () => selectedPack && !isLoading && tableColumns.length > 0,
    [selectedPack, isLoading, tableColumns]
  );

  const handleCreateRequestClick = () => {
    dispatch(GenerateAssets());
    if (!openModal) return;
    openModal<ModalNewRequestCheckElementProps>(ModalNewRequestCheck, {
      onConfirm: handleConfirmTopologyClick,
    });
  };

  const handleConfirmTopologyClick = () => {
    dispatch(CreateRequests());
    if (!openModal) return;
    openModal<ModalNewRequestBrokerElementProps>(ModalNewRequestBroker, {});
  };

  useEffect(() => {
    if (fetchedPacks.length === 0)
      ingestService.GetConfigPackList().then((response) => dispatch(SetFetchedPacks(response.packs || [])));
    if (params.id)
      assetService.GetObjectById(Number(params.id)).then((response) => {
        if (response.graph) dispatch(SetSelectedTitles([response.graph]));
      });
    ingestService.GetIngestMetadataFields().then((response) => {
      dispatch(SetFetchedColumnGroups(response.columns || []));
    });
    ingestService.GetMyPersonalBackups().then((response) => {
      // dispatch
      dispatch(SetBackups(response.backups || []));
    });
  }, []);

  // #region Tuto
  useEffect(() => {
    const show = cacheService
      .GetUserInfo()!
      .startup?.tutorials?.includes(StartupHelpTutorialType.IngestNewRequest) as boolean;
    setShowTuto(show);
  }, [helpPopupAnchorEl]);

  const handleHelpClick: React.MouseEventHandler<HTMLElement> = (e) => {
    e.stopPropagation();
    setHelpPopupAnchorEl(e.currentTarget);
  };

  const onClosePopup = () => {
    setHelpPopupAnchorEl(null);
  };

  useEffect(() => {
    if (!setTutorialPage) {
      return;
    }

    setTutorialPage("request");
  }, [setTutorialPage]);
  // #endregion Tuto

  return (
    <FullTaskLayout
      subbarHeight={80}
      sxWrapper={{ height: "100vh" }}
      TopBar={
        <FullTaskTopbar
          backRoute={routePaths.ingest.path}
          title={t("page:fullTaskTopbar.title.createNewRequest")}
          rightContent={
            <Stack direction="row" spacing={1}>
              {UserHasAcl(AclTypes.aclSupportTicketCreate) && GlobalConst.ZENDESK_ENABLED && (
                <Button
                  startIcon={<ReportProblemIcon />}
                  onClick={() => {
                    let text = "";

                    if (selectedTitles.length > 0) {
                      let ids = selectedTitles.map((title) => title.id);
                      const titleIds = ids.join(", ");
                      text += `\nTitle id(s): ${titleIds}`;
                    }

                    if (selectedPack) text += `\nPack name: ${selectedPack.name}`;

                    if (!openModal) return;

                    openModal<ModalReportIssueElementProps>(ModalReportIssue, {
                      typology: "Ingest",
                      techInfos: text,
                      onConfirm: (subject, subTypology, priority, followers, description, file) => {
                        let requestData = {
                          subject: subject,
                          techInfos: text ?? "",
                          description: description ?? "",
                          typology: "Ingest",
                          subTypology: subTypology,
                          objectId: -500,
                          priority: priority,
                          followers: followers,
                          [immerable]: true,
                        };

                        supportService.CreateZendeskIssue(requestData, file).then((response) => {
                          if (response.success) {
                            enqueueSnackbar(t("alert:success.ticketCreated"), "success");
                          }
                        });
                      },
                    });
                  }}
                  sx={{ mr: 2 }}
                  variant="contained"
                  color={"info"}
                >
                  {t("modal:title.reportIssue")}
                </Button>
              )}

              <ConfigManagerMenuButton />
              <Button
                id="tutorial-request-new"
                color="primary"
                variant="contained"
                onClick={handleCreateRequestClick}
                disabled={!rows.length || isTableErrored || selectedTitles.length === 0}
              >
                {t("button:createRequest")}
              </Button>
            </Stack>
          }
        />
      }
      Subbar={<NewRequestSubbar onEditClick={toggleManageTitlePanel} />}
      Tabbar={
        <Stack direction="row" alignItems="center" spacing={2} justifyContent="space-between" width="100%">
          <Stack direction="row">
            {!selectedTab || !selectedPack || isLoading ? (
              <Box></Box>
            ) : (
              <Tabs value={selectedTab} onChange={(e, groupName) => dispatch(SetSelectedTab(groupName))}>
                {columnGroups
                  .filter((g) => g.show)
                  .map((group, index) => (
                    <Tab
                      key={index}
                      label={
                        <Stack direction="row">
                          {group.name}
                          {groupErrors.find((g) => g.groupName === group.name)?.isErrored && (
                            <RequiredIndicator sx={{ ml: 0.5, mt: 0.75 }} />
                          )}
                        </Stack>
                      }
                      value={group.name}
                    />
                  ))}
                {/* <Divider orientation="vertical" sx={{ height: 30, borderWidth: 1 }} /> TODO : this pops errors in console, try to fix it */}
                <Tab label={t("common:all")} value={"all"} />
              </Tabs>
            )}
          </Stack>
          {helpPopupAnchorEl && (
            <HelpPopup visible={Boolean(helpPopupAnchorEl)} onClose={onClosePopup} anchorEl={helpPopupAnchorEl} />
          )}
          <Stack direction="row" alignItems="center" spacing={1}>
            <Button
              id="tutorial-request-export"
              size="small"
              startIcon={<FileDownloadOutlinedIcon />}
              onClick={() => dispatch(DownloadTableAsCsv())}
              disabled={!displayTable}
            >
              {t("common:export")}
            </Button>
            <Button
              id="tutorial-request-columns"
              size="small"
              startIcon={<RuleOutlinedIcon />}
              onClick={toggleFilterPanel}
              disabled={!selectedPack || isLoading}
            >
              {t("common:columns")}
            </Button>
            <Button
              id="tutorial-request-placeholders"
              size="small"
              startIcon={
                isMarketplaceLoading ? <CircularProgress disableShrink color="inherit" size={15} /> : <AddIcon />
              }
              variant="contained"
              color="primary"
              onClick={toggleMarketplacePanel}
              disabled={!selectedPack || isLoading}
            >
              {t("common:placeholders")}
            </Button>
            {/* Decomment for don't show anymore option */}
            {showTuto && (
              <Button
                size="small"
                startIcon={
                  <Avatar sx={{ bgcolor: "info.main", width: 24, height: 24 }}>
                    <HeadsetMicOutlinedIcon sx={{ width: 16, height: 16 }} />
                  </Avatar>
                }
                onClick={handleHelpClick}
                sx={{ padding: "3px 1px 4px 8px" }}
              ></Button>
            )}
          </Stack>
        </Stack>
      }
      sxStack={{ flex: "1 1 0%", width: "100%", marginTop: "216px", px: 2 }}
    >
      {displayTable && (
        <GroupColumnTable
          isLoading={isLoading}
          rows={rows}
          columns={tableColumns}
          // manage height in table
          //autoHeight
          columnHeaderHeight={48}
          getRowHeight={() => "auto"}
          //pin placeholderName to left
          initialState={{
            pinnedColumns: {
              left: ["placeHolderName"],
            },
          }}
          // select tab when group change
          onChangeExpandedGroup={(group) => dispatch(SetSelectedTab(group))}
          // sx={{
          //     overflowX: "scroll",
          //     //overflowY: "scroll",
          //     left: 0,
          //     right: 0,
          //     position: "absolute",
          //     pl: 2.5,
          //     pr: 2.5,
          //     height: "80%",
          // }}
          // columns virtualization (pre render)
          // columnBufferPx={200}
          // rows virtualization (pre render)
          // rowBufferPx={200}
          apiRef={apiGrid}
        />
      )}
      <NewRequestPanel type="update" open={panelManageTitlesOpen} onClose={toggleManageTitlePanel} />
      <MarketplacePlaceholdersPanel
        open={panelMarketplaceOpen}
        onClose={toggleMarketplacePanel}
        closePanel={toggleMarketplacePanel}
      />
      <NewRequestFilterPanel open={panelFilterOpen} onClose={toggleFilterPanel} />
    </FullTaskLayout>
  );
}

export default IngestNewRequest;

const TableCellHeader = (props: { headerName: string; columnMetadataFieldId: number }) => {
  const { headerName, columnMetadataFieldId } = props;

  const errorNumber = useAppSelector((state) => GetColumnErrorNumberCached(state, columnMetadataFieldId));

  return (
    <>
      {headerName}{" "}
      {errorNumber > 0 && (
        <Box id="tutorial-request-missing">
          <Chip sx={{ ml: 2 }} label={errorNumber} color="error" size="small" />
        </Box>
      )}
    </>
  );
};

const TableCellRequestStatus = (props: { columnsIds: number[]; placeholderRowId: number }) => {
  const { columnsIds, placeholderRowId } = props;

  //const errorNumber = useAppSelector(GetRowGroupedErrorNumber(columnsIds, placeholderRowId));
  const errorNumber = useAppSelector((state) => GetRowGroupedErrorNumberCached(state, columnsIds, placeholderRowId));

  if (errorNumber > 0) {
    return <Chip label={errorNumber} color="error" variant="outlined" sx={{ ".MuiChip-label": { pl: 1, pr: 1 } }} />;
  }
  return <CheckIcon sx={{ color: "text.placeholder" }} />;
};

const NameCell = styled(Stack)(({ theme }) => ({
  height: "100%",
  width: "100%",
  paddingRight: theme.spacing(2),
  ".MuiIconButton-root": {
    opacity: 0,
    transition: "opacity .3s",
  },
  "&:hover": {
    ".MuiIconButton-root": {
      opacity: 1,
    },
  },
}));

const ConfigManagerMenuButton: FC<{ disabled?: boolean | undefined }> = ({ disabled = false }) => {
  const { t } = useTranslation();
  const [anchorMoreEl, setAnchorMoreEl] = useState<null | HTMLElement>(null);
  const enqueueSnackbar = useCustomSnackbar();

  // Modals
  const modalContext = useContext(ModalContext);
  const { openModal } = { ...modalContext };

  const canSaveOrUpdateConfig = useAppSelector(GetCanUpdateOrSaveConfig);

  const handleMoreClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setAnchorMoreEl(e.currentTarget);
  };
  const handleMoreClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setAnchorMoreEl(null);
  };

  const openMore = Boolean(anchorMoreEl);

  const handleUpdateConfigClick = useCallback(() => {
    if (!openModal) return;
    openModal<ModalNewRequestUpdateConfigElementProps>(ModalNewRequestUpdateConfig, {});
    setAnchorMoreEl(null);
  }, []);
  const handleSaveConfigClick = useCallback(() => {
    if (!openModal) return;
    openModal<ModalNewRequestSaveConfigElementProps>(ModalNewRequestSaveConfig, {});
    setAnchorMoreEl(null);
  }, []);
  const handleRestoreConfigClick = useCallback(() => {
    if (!openModal) return;
    openModal<ModalNewRequestLoadConfigElementProps>(ModalNewRequestLoadConfig, {});
    setAnchorMoreEl(null);
  }, []);
  const handleDeleteConfigClick = useCallback(() => {
    if (!openModal) return;
    openModal<ModalNewRequestDeleteConfigElementProps>(ModalNewRequestDeleteConfig, {});
    setAnchorMoreEl(null);
  }, []);

  return (
    <>
      <Button endIcon={<ExpandMoreRoundedIcon />} onClick={handleMoreClick} sx={{ mr: 2 }} disabled={disabled}>
        {t("button:configurationManager")}
      </Button>
      <Menu
        id="export-menu"
        MenuListProps={{
          "aria-labelledby": "export-menu-button",
        }}
        anchorEl={anchorMoreEl}
        open={openMore}
        onClose={handleMoreClose}
        anchorPosition={{
          top: 12,
          left: 0,
        }}
      >
        <MenuItem onClick={handleRestoreConfigClick}>
          <ListItemIcon>
            <RestoreOutlinedIcon />
          </ListItemIcon>
          <ListItemText>{t("modal:title.restoreConfiguration")}</ListItemText>
        </MenuItem>
        <MenuItem disabled={!canSaveOrUpdateConfig} onClick={handleUpdateConfigClick}>
          <ListItemIcon>
            <UpdateOutlinedIcon />
          </ListItemIcon>
          <ListItemText>{t("modal:title.updateAConfiguration")}</ListItemText>
        </MenuItem>
        <MenuItem disabled={!canSaveOrUpdateConfig} onClick={handleSaveConfigClick}>
          <ListItemIcon>
            <SaveOutlinedIcon />
          </ListItemIcon>
          <ListItemText>{t("modal:title.saveConfiguration")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleDeleteConfigClick}>
          <ListItemIcon>
            <DeleteOutlineOutlinedIcon />
          </ListItemIcon>
          <ListItemText>{t("modal:title.deleteConfiguration")}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
